export function GiftIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.6" aria-hidden="true">
      <rect x="3" y="8" width="14" height="9" rx="1" />
      <path d="M3 8h14M10 8v9M10 8c-2.5 0-4-1-4-2.5S7 3 8 4s2 4 2 4Zm0 0c2.5 0 4-1 4-2.5S13 3 12 4s-2 4-2 4Z" />
    </svg>
  );
}

export function TagIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.6" aria-hidden="true">
      <path d="M10.5 3H4v6.5L11 16.5l6-6L10.5 3Z" strokeLinejoin="round" />
      <circle cx="7" cy="6.5" r="1" fill="currentColor" stroke="none" />
    </svg>
  );
}

export function GripIcon() {
  return (
    <svg width="10" height="16" viewBox="0 0 10 16" fill="currentColor" aria-hidden="true">
      {[3, 8, 13].map((cy) =>
        [2, 8].map((cx) => <circle key={`${cx}-${cy}`} cx={cx} cy={cy} r="1.25" />),
      )}
    </svg>
  );
}

export function CheckIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
      <path d="m3 8 3.5 3.5L13 5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export function XIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
      <path d="M4 4l8 8M12 4l-8 8" strokeLinecap="round" />
    </svg>
  );
}

export function MailIcon() {
  return (
    <svg width="14" height="14" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.6" className="flex-shrink-0" aria-hidden="true">
      <rect x="2" y="3.5" width="12" height="9" rx="1.2" />
      <path d="M2.5 4.5 8 8.5l5.5-4" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export function PhoneIcon() {
  return (
    <svg width="14" height="14" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.6" className="flex-shrink-0" aria-hidden="true">
      <path
        d="M4.5 2.5 6 4.8c.3.4.2 1-.2 1.3l-1 .8a7.5 7.5 0 0 0 4.3 4.3l.8-1c.3-.4.9-.5 1.3-.2l2.3 1.5c.5.3.6 1 .2 1.4l-1 1c-.5.5-1.3.7-2 .5-4.2-1.2-7.4-4.4-8.6-8.6-.2-.7 0-1.5.5-2l1-1c.4-.4 1.1-.3 1.4.2Z"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function ShopifyIcon() {
  return (
    <svg width="15" height="15" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.6" aria-hidden="true">
      <path d="M9.5 3.5H12.5V6.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M12.5 3.5 7.5 8.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M11 9.5V12a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h2.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export function FlagIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.6" aria-hidden="true">
      <path d="M4 2v12" strokeLinecap="round" />
      <path d="M4 2.5h7.5l-1.5 3 1.5 3H4" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export function PencilIcon() {
  return (
    <svg width="14" height="14" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.6" aria-hidden="true">
      <path d="M11.5 2.5l2 2L6 12l-3 1 1-3 7.5-7.5Z" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export function BagIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.6" aria-hidden="true">
      <path d="M4 6h12l-1 10H5L4 6Z" strokeLinejoin="round" />
      <path d="M7 6a3 3 0 0 1 6 0" strokeLinecap="round" />
    </svg>
  );
}

export function CheckmarkIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
      <path d="m4 10 4 4 8-9" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export function AlertIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.8" aria-hidden="true">
      <circle cx="10" cy="10" r="7.5" />
      <path d="M10 6v4.5M10 13.5h.01" strokeLinecap="round" />
    </svg>
  );
}

export function ChevronIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" stroke="currentColor" strokeWidth="1.8" aria-hidden="true">
      <path d="m7 4 5 5-5 5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export function LightningIcon() {
  return (
    <svg width="14" height="14" viewBox="0 0 16 16" fill="currentColor" aria-hidden="true">
      <path d="M9 1 3 9h4l-1 6 6-8H8l1-6Z" />
    </svg>
  );
}

export function TrashIcon() {
  return (
    <svg width="15" height="15" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.4" aria-hidden="true">
      <path d="M3 4.5h10M6.5 4.5v-1a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v1M6 7.5l.4 5M10 7.5l-.4 5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M4 4.5 4.6 13a1 1 0 0 0 1 .9h4.8a1 1 0 0 0 1-.9l.6-8.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export function FilterIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.6" aria-hidden="true">
      <path d="M2 4h12M4 8h8M6 12h4" strokeLinecap="round" />
    </svg>
  );
}

export function CalendarIcon() {
  return (
    <svg width="15" height="15" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5" className="text-ink-subtle" aria-hidden="true">
      <rect x="2.5" y="3" width="11" height="10.5" rx="1.5" />
      <path d="M2.5 6h11M5.5 1.5v3M10.5 1.5v3" strokeLinecap="round" />
    </svg>
  );
}

export function ArrowIcon() {
  return (
    <svg width="16" height="12" viewBox="0 0 16 12" fill="none" stroke="currentColor" strokeWidth="1.5" className="flex-shrink-0 text-ink-subtle" aria-hidden="true">
      <path d="M2 6h11M9.5 2.5 13 6l-3.5 3.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export function FastrrLogo() {
  return (
    <svg width="170" height="132" viewBox="0 0 170 132" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect y="-15" width="170" height="170" fill="url(#pattern0_2900_145381)"/>
    <defs>
    <pattern id="pattern0_2900_145381" patternContentUnits="objectBoundingBox" width="1" height="1">
    <use href="#image0_2900_145381" transform="scale(0.00588235)"/>
    </pattern>
    <image id="image0_2900_145381" width="170" height="170" preserveAspectRatio="none"  href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAKoAAACqCAYAAAA9dtSCAAAFJklEQVR42uzdzXHbRhgGYESTApQKzBx1inLy0XAFUQemKkhSgaUKNKrA7MByBSSPOpk6+WiqArEDBbCgGSWToUhgl8AunmcGw9FoxJ/lq293icWyKAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEjGT5qAiMr//LypjpWg0kcQT6vjTXN73Nxus6iO9/s+0M/amj1MquOsOt41t220qqiCyi6m1fHhf7ryNu41JzEC+r06HgMepWYllLMIAX0+jjUvXdUh+hwpoI9N+KGT04hV9PmYt31yR94fmnHjvJnVx7QUVLpMmOYHGjuuNTdtu/uHyN29GT+dTA4c0kdNThtfDxzSTjN+Y9RxuihePycf2kqzs2+X/9jDcaGiso9PPT2uisrOyp6q6WMPQw0SNu8xqJ1Y5jeusWl5wG5+8+LnteZnV1eRK2Y99j3TzHQVa8HJd+NPQjmNFNKHIv5Clh98PDUOsbrkc+NPQopxunSuWQktRrc/1ayEVBYZrIQyRh3HRCq0haAS2m8R7nN56BdhS588KubVK78PfZnJeo/Z/nV13HibuCj6O39/sMtPdP269thWgkptMuDntin+vThFUM3q862mgiqksS0FlRSCuhZUhj4+DRpU0tbnpSUHPc2qoqqog59I1ZK/Zmr69ltZPH2oXH+eOORNYutu8Mvs9iTUWZrjgQd1LahPAa3fpE9FWhtvTavnXVea8yqwXSvO0CdSd6Pv+puQfi3S3B2uDti8eg1nmQd1NfqgFk/bd6e8F3z93D81/3BtvRnTjD+5oFZv7rTI46rH46Lb9joq6sD9mdGsvexQVYc87FmEvsOkglq9qbt8hWFyYW3xN5OBv6Z16DtMbdaf40YHbUN3ueV3HyKEeVbs/q17i7EHNUdtxnJ1xbrY8vuPEZ7nZdHjKdGjEbypY3tNsYYF6z4bKamgzm5PNpmFdVW9ptAByOKq0xxm/ZcZBTXGa4kR1LWg7l9Vb5qBfepuAp73fynGNVR3gtourOeJh/XH+f6BfYow6LlB0tf1N2epPhbD/1zxWT3Gvq7+0S4iPkaM7XZ+KQJdpDfKoL4IbIxNFoKHNMCKqdeURfhd9jZNUCHc/2yR6faSVvjnJcYQaCmohPYuwn2uBZXQTnMNqt388lFPJh9yzYiKqpoOvpoKqqC+ZiWohBbjGqo7QUVFZZR8dTmDNyky+IqebYJdihLqwrvZ7clC7loFNbRFVkFtAhrsK7Cr+8spQPUY7zLSutOXygj3uR5SQx4FCOm88D3t2yY4n6t2uor8ODEWS99nE9TKXwbcu7VTgL2mRt31tz491lTTBxncvSuthgC/Rpzxh9b7YulQFXUqe/tVvWaBd4zhRWibIYW0a1D/kL29nSUS1MF90N8lqKXc7S3GetGJoDLW8N/nFNSNjAyiUqmoqb2YBIRejRTrCycWOQX1i9zt1wPNbk9mCUyk1kNsvC5Bnen+9/J3IjP+vILa7Kx3LX+7NVeEalqLsVh6mVVQm7BeVDc3cri9kjZ7ZcUwmsXSQa4wnL79Vp/zH9IJgL73+l80lWkWYf/Tlx6K8FsZ/W6iTEj1bD/rxdLBun56D+ooun1BTVspqKQgxoz/XlBJYca/0KyEFmMiNdGshK6mo5nx6/rN+JPp9gXV+HTwM35BTdcoFksLqq4/uYpqx+l0Z/yhDeryaBU1fWWE+1wXA19bLKi6/eegFoLK0IO61KwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAE848AAwAQVDAGgrlMtQAAAABJRU5ErkJggg=="/>
    </defs>
    </svg>
  );
}

export function RoiBarsIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
      <path d="M5 14v3M10 9v8M15 5v12" strokeLinecap="round" />
    </svg>
  );
}

export function RoiWalletIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.6" aria-hidden="true">
      <path d="M3 6.5A1.5 1.5 0 0 1 4.5 5H14v3" strokeLinecap="round" strokeLinejoin="round" />
      <rect x="3" y="6.5" width="14" height="9.5" rx="1.8" />
      <path d="M17 10h-2.5a1.5 1.5 0 0 0 0 3H17" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export function RoiExchangeIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.8" aria-hidden="true">
      <path d="M3 7.5h11l-3-3M17 12.5H6l3 3" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export function RoiBankIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.6" aria-hidden="true">
      <path d="M3 8 10 3.5 17 8" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M4.5 8v6M8 8v6M12 8v6M15.5 8v6M3 16.5h14" strokeLinecap="round" />
    </svg>
  );
}

export function RoiClockIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.6" aria-hidden="true">
      <circle cx="10" cy="10" r="7" />
      <path d="M10 6v4l2.5 1.8" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

